import { Injectable, EventEmitter } from "@angular/core";

@Injectable({ providedIn: "root" })
export class EventService {
	public getData = new EventEmitter();
    public getTrashData = new EventEmitter();
    public getGlobalData = new EventEmitter();
    public onThemePrefChange  = new EventEmitter();
    public onCurrentUserSessionRevoked = new EventEmitter();
    public logoutEvent = new EventEmitter();
    public checkUnreadMessages =  new EventEmitter();
    public resetRowsSelection =  new EventEmitter();
    public searchContacts = new EventEmitter();
    public callBack = new EventEmitter();
    public sendResponseToLolly = new EventEmitter();
    public multiRowSelect = new EventEmitter();
    public onSearchClear = new EventEmitter();
    //Copilot Events
    public toggleCopilot = new EventEmitter();
    public changeCurrentAssetSession = new EventEmitter();
    public deleteCopilotAssetSession = new EventEmitter();
    public newCopilotChat = new EventEmitter();
    public createEntityFromCopilot = new EventEmitter();
    public onRouteChange = new EventEmitter();
    public onAssetNotification = new EventEmitter<{ assetId: string; parentId: string }>();
    constructor(){}
}
